import {
  ActiveInactiveStatus,
  ApiListResponse,
  CancellationDatesDTO,
  MembershipBean,
  MembershipSummaryDTO,
  MembershipType,
  SubscriptionPendingStartDateDTO,
} from "@gymflow/types";
import { AxiosInstance } from "axios";

export type CustomerMembershipApiType = ReturnType<
  typeof customerMembershipApi
>;

const customerMembershipApi = (
  axiosInstance: AxiosInstance,
  clubId: number,
) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    getById(id: number) {
      return axiosInstance.get<MembershipBean>(
        `${clubPrefix}customer/membership/${id}`,
      );
    },
    summary(params: {
      membershipId: number;
      promotionCode?: string;
      startDate?: string;
    }) {
      return axiosInstance.get<MembershipSummaryDTO>(
        `${clubPrefix}customer/membership-signup/summary`,
        { params },
      );
    },
    getList(params: {
      status?: ActiveInactiveStatus;
      id?: number[];
      page: number;
      size: number;
      sort?: string;
      type?: MembershipType;
      isTrial?: boolean;
    }) {
      return axiosInstance.get<ApiListResponse<MembershipBean>>(
        `${clubPrefix}customer/membership`,
        {
          params,
        },
      );
    },
    calculateCancelDates({ membershipId }: { membershipId: number }) {
      return axiosInstance.get<CancellationDatesDTO>(
        `${clubPrefix}customer/user/member/membership/calculate-cancel-dates/${membershipId}`,
      );
    },
    membershipCancelByMembershipId({
      membershipId,
      cancellationDate,
      cancellationReasonId,
    }: {
      membershipId: number;
      cancellationDate: string;
      cancellationReasonId: number;
    }) {
      return axiosInstance.post(
        `${clubPrefix}customer/user/member/membership/cancel/${membershipId}`,
        { cancellationDate, cancellationReasonId },
      );
    },
    membershipRevokeCancellationByMembershipId({
      subscriptionId,
    }: {
      subscriptionId: number;
    }) {
      return axiosInstance.post(
        `${clubPrefix}customer/user/member/membership/revoke-cancellation/${subscriptionId}`,
      );
    },
    membershipUnlinkSecondary({ subscriptionId }: { subscriptionId: number }) {
      return axiosInstance.delete(
        `${clubPrefix}customer/subscription/${subscriptionId}/primary-link`,
      );
    },
    membershipSubscriptionStartDate({
      subscriptionId,
      params,
    }: {
      subscriptionId: number;
      params: SubscriptionPendingStartDateDTO;
    }) {
      return axiosInstance.put(
        `${clubPrefix}customer/subscription/${subscriptionId}/start-date`,
        params,
      );
    },
  };
};

export default customerMembershipApi;
